// Fetch wrapper that injects the bearer token + backend base URL.
// Mirrors the mobile client (src/api.ts) so both surfaces share one contract.
const BASE = process.env.REACT_APP_BACKEND_URL;

const TOKEN_KEY = "rb_token";

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null;
}

export async function api(path, opts = {}) {
  const headers = { "Content-Type": "application/json" };
  if (opts.auth !== false) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${BASE}/api${path}`, {
    method: opts.method || "GET",
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (!res.ok) {
    let detail = await res.text();
    try {
      detail = JSON.parse(detail).detail || detail;
    } catch (e) {
      console.debug("api: error body was not JSON, using raw text", e);
    }
    const err = new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  if (opts.raw) return res.blob();
  if (res.status === 204) return null;
  return res.json();
}

export function pdfUrl(qs = "") {
  return `${BASE}/api/reports/export-pdf${qs ? `?${qs}` : ""}`;
}

export function csvUrl(qs = "") {
  return `${BASE}/api/reports/export-csv${qs ? `?${qs}` : ""}`;
}

// Download an authenticated PDF (export or share) as a file in the browser.
export async function downloadPdf(url, filename) {
  const token = getToken();
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const u = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(u);
}

export function mediaUrl(p) {
  if (!p) return p;
  return /^https?:\/\//.test(p) ? p : `${BASE}${p}`;
}

export function iftaPdfUrl(qs = "") {
  return `${BASE}/api/reports/ifta-pdf${qs ? `?${qs}` : ""}`;
}

export async function uploadAvatar(file) {
  const token = getToken();
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${BASE}/api/profile/avatar`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  });
  if (!res.ok) {
    let detail = await res.text();
    try {
      detail = JSON.parse(detail).detail || detail;
    } catch (e) {
      console.debug("api: error body was not JSON, using raw text", e);
    }
    throw new Error(typeof detail === "string" ? detail : "Upload failed");
  }
  return res.json();
}

export { BASE as BACKEND_BASE };
